import { Component, OnInit, OnDestroy } from '@angular/core';

import { Platform, MenuController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Router, NavigationStart } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
import { ServerService } from './services/server.service';
import { GameService } from './services/game.service';
import { UtilityService } from './services/utility.service';
import { SwUpdate } from '@angular/service-worker';
import { Subscription } from 'rxjs';
import { NgcCookieConsentService, NgcInitializeEvent, NgcStatusChangeEvent, NgcNoCookieLawEvent } from 'ngx-cookieconsent';

export let browserRefresh = false;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  private popupOpenSubscription: Subscription;
  private popupCloseSubscription: Subscription;
  private initializeSubscription: Subscription;
  private statusChangeSubscription: Subscription;
  private revokeChoiceSubscription: Subscription;
  private noCookieLawSubscription: Subscription;
  spinner: boolean = false
  subscription: Subscription;

  constructor(
    private platform: Platform,
    private swUpdate: SwUpdate,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private utilitySrv: UtilityService,
    private router: Router,
    private menuCtrl: MenuController,
    private gameSrv: GameService,
    public authSrv: AuthenticationService,
    public serverSrv: ServerService,
    private ccService: NgcCookieConsentService,
  ) {
    this.initializeApp();
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
      }
  });
  }



  initializeApp() {
    this.platform.ready().then(() => {

      this.statusBar.styleDefault();

      this.splashScreen.hide();
      this.checkForUpdate()
    });
  }

  ngOnInit() {
    this.ccService.getConfig().content = this.ccService.getConfig().content || {};
    // Override default messages with the translated ones

    this.ccService.getConfig().content.header = "Questo sito utilizza cookies!"
    this.ccService.getConfig().content.message = "Questo sito utilizza i cookies per assicurarti un'esperienza migliore"
    this.ccService.getConfig().content.dismiss = "Accetta cookies"
    this.ccService.getConfig().content.link = "Leggi di più"


    this.ccService.destroy();//remove previous cookie bar (with default messages)
    this.ccService.init(this.ccService.getConfig());


    // subscribe to cookieconsent observables to react to main events
    this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(
      () => {

        // you can use this.ccService.getConfig() to do stuff...
      });

    this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
      () => {

        // you can use this.ccService.getConfig() to do stuff...
      });

    this.initializeSubscription = this.ccService.initialize$.subscribe(
      (event: NgcInitializeEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
      });

    this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
      (event: NgcStatusChangeEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
      });

    this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
      () => {
        // you can use this.ccService.getConfig() to do stuff...
      });

    this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
      (event: NgcNoCookieLawEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
      });
  }

  playGameAllenamento() {
    if (this.authSrv.config.allenamentoDisabled) {
      this.utilitySrv.presentGenericModal("Informazione", 'Funzionalità momentaneamente disabilitata', false)
    } else {
      this.router.navigate(['home', 'seleziona-difficolta']); // prima game
      this.menuCtrl.close();
      this.gameSrv.idTournament = null
      this.gameSrv.isPlayer=true;
      this.gameSrv.firstGamer=undefined;
      this.gameSrv.uidFirstGamer=undefined;
    }

  }

  playGameQualificazione() {
    if (this.authSrv.config.qualificazioneDisabled) {
      this.utilitySrv.presentGenericModal("Informazione", 'Funzionalità momentaneamente disabilitata', false)
    } else {
      this.router.navigate(['home', 'qualificazioni']);
      this.menuCtrl.close();
      this.gameSrv.idTournament = this.authSrv.config.tournamentId;
      this.gameSrv.isPlayer=true;
      this.gameSrv.firstGamer=undefined;
      this.gameSrv.uidFirstGamer=undefined;
    }

  }

  playGameTorneo() {
    this.router.navigate(['home', 'game']);
    this.menuCtrl.close();
    this.gameSrv.isPlayer=true;
    this.gameSrv.firstGamer=undefined;
    this.gameSrv.uidFirstGamer=undefined;
    this.gameSrv.idTournament = this.authSrv.config.tournamentId;
  }

  goToTabellone() {
    if (this.authSrv.config.tabelloneDisabled) {
      this.utilitySrv.presentGenericModal("Informazione", 'Funzionalità momentaneamente disabilitata', false)
    } else {
      this.router.navigate(['home', 'tabellone']);
      this.menuCtrl.close();
    }

  }

  goToHome() {
    this.router.navigate(['home']);
    this.menuCtrl.close();
  }

  onMenuLogin() {
    if (this.authSrv.config.loginDisabled) {
      this.utilitySrv.presentGenericModal("Informazione", 'Funzionalità momentaneamente disabilitata', false)
    } else {
      this.router.navigate(['home', 'login']);
      this.menuCtrl.close();
    }


  }

  onMenuLogout() {
    // this.gameSrv.userIsLoggedIn = false;
    this.authSrv.SignOut();
    this.goToHome();
  }

  goToClassificaComputer() {
    this.router.navigate(['home', 'classifica-computer']);
    this.menuCtrl.close();
  }

  goToMatchmaking() {
    this.router.navigate(['home', 'matchmaking']);
    this.menuCtrl.close();
  }

  goToQuestionsSettings() {
    this.router.navigate(['home', 'gestione-domande']);
    this.menuCtrl.close();
  }

  goToAdmin() {
    this.router.navigate(['home', 'amministrazione']);
    this.menuCtrl.close();
  }

  goToAnalytics() {
    this.router.navigate(['home', 'statistiche']);
    this.menuCtrl.close();
  }

  goToRegolamento() {
    this.router.navigate(['home', 'regolamento-torneo']);
    this.menuCtrl.close();
  }

  goToInfo() {
    this.router.navigate(['home', 'info-torneo']);
    this.menuCtrl.close();
  }

  goToInfoGioco() {
    this.router.navigate(['home', 'info-gioco']);
    this.menuCtrl.close();
  }

  onMenuTournamentSubscribe() {
    this.router.navigate(['home', 'torneo']);
    this.menuCtrl.close();
  }

  onAdminPage() {
    this.router.navigate(['home', 'admin']);
    this.menuCtrl.close();
  }


  checkForUpdate() {
    this.swUpdate.available.subscribe(evt => {
      console.log(evt);
      this.swUpdate.activateUpdate()
        .then(() => window.location.reload())
        .catch(err => console.log("error in update", err))
    }, err => console.log("error in subscribe update", err));
  }

  ngOnDestroy() {
    // unsubscribe to cookieconsent observables to prevent memory leaks
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    this.initializeSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
  }
}
